import {
    trigger, animateChild, group,
    transition, animate, style, query,
    animation
  } from '@angular/animations';
  
  
  // Routable animations
  export const slideInAnimation =
    trigger('routeAnimation', [
      transition('heroes <=> hero', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
          style({
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%'
          })
        ]),
        query(':enter', [
          style({ left: '-100%'})
        ]),
        query(':leave', animateChild()),
        group([
          query(':leave', [
            animate('300ms ease-out', style({ left: '100%'}))
          ]),
          query(':enter', [
            animate('500ms ease-out', style({ left: '0%'}))
          ])
        ]),
        query(':enter', animateChild()),
      ])
    ]);

    export var fadeAnimation = animation([
      style({
        opacity: 0
      }),
      animate("{{ delay }} ease-in-out", style({ 
        opacity: 1
      }))
    ])

    export var slideAnimation = animation([
        style({ opacity: 0,  transform: 'translate3d(100%, 0, 0)'}),
        animate('400ms ease-in-out', style({
          opacity: 1, transform: 'translate3d(0%, 0, 0)'
        }))
    ])

    export var slideDownAnimation = animation([
      style({ opacity: 0,  transform: 'translate3d(0, -100%, 0)'}),
      animate('400ms ease-in-out', style({
        opacity: 1, transform: 'translate3d(0%, 0, 0)'
      }))
  ])